import ButtonT from '@components/tailwind-components/Button/ButtonT';
import InputWithLabelT from '@components/tailwind-components/Input/InputWithLabelT';
import type React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useModal } from '../../../../hooks/modal/useModal';
import type {
  TCannedResponse,
  TCannedResponseUpdatable,
} from '../../../../interfaces/TChat';

type Props = {
  cannedResponseData?: Partial<TCannedResponse>;
  onSubmit: (data: TCannedResponseUpdatable) => void;
};

type TCannedResponseFormData = TCannedResponseUpdatable;

export const CannedResponseDataModal: React.FC<Props> = ({
  cannedResponseData,
  onSubmit,
}) => {
  const { handleSubmit, control } = useForm<TCannedResponseFormData>({
    shouldUseNativeValidation: true,
    defaultValues: {
      message: cannedResponseData?.message,
      shorthand: cannedResponseData?.shorthand,
    },
  });

  const { t } = useTranslation();
  const { hideModal } = useModal();

  const hideAndSubmit = (data: TCannedResponseFormData) => {
    onSubmit({
      message: data.message,
      shorthand: data.shorthand,
    });
    hideModal();
  };

  return (
    <form
      className='tailwind-modal-form'
      onSubmit={handleSubmit(hideAndSubmit)}>
      <div className='tailwind-modal-body'>
        <div className='grid grid-cols-1 gap-x-6 gap-y-2'>
          <div className='col-span-1'>
            <InputWithLabelT
              type='text'
              field='shorthand'
              placeholder={t('settings.canned-response.shorthand')}
              label={t('settings.canned-response.shorthand')}
              id='shorthand'
              control={control}
              options={{
                required: t('settings.canned-response.validation.shorthand'),
              }}
            />
          </div>

          <div className='col-span-1'>
            <InputWithLabelT
              type='text'
              field='message'
              placeholder={t('settings.canned-response.response')}
              label={t('settings.canned-response.response')}
              id='message'
              control={control}
              options={{
                required: t('settings.canned-response.validation.response'),
              }}
            />
          </div>
        </div>
      </div>
      <div className='tailwind-modal-footer'>
        <ButtonT
          type='button'
          styling='cancel'
          size='xs'
          rounding='md'
          onClick={hideModal}>
          {t('general.buttons.cancel')}
        </ButtonT>
        <ButtonT type='submit' styling='primary' size='xs' rounding='md'>
          {t('general.buttons.save')}
        </ButtonT>
      </div>
    </form>
  );
};

export default CannedResponseDataModal;
